var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClaimsLanding',{attrs:{"start-claim-img":_vm.startClaimImg,"is-mobile":_vm.isMobile,"can-show-ev-claim":_vm.canShowEvClaim,"can-show-history":""},on:{"start:claim":_vm.goToClaimsNew,"view:history":_vm.goToClaimsHistory}})
}
var staticRenderFns = []

export { render, staticRenderFns }